import smoothScrollByPosition from './smoothScrollByPosition';
export default smoothScrollByPosition;